(() => {
  'use strict';
  const root = window.Shopify?.routes?.root || '/';
  document.querySelectorAll('[data-adler-net-cart]').forEach(cart => {
    if (cart.dataset.netInitialized) return;
    cart.dataset.netInitialized = 'true';
    const form = cart.querySelector('form');
    if (!form) return;
    const messages = {...window.adlerRefinement, ...JSON.parse(cart.querySelector('[data-cart-net-messages]').textContent)};
    const box = cart.querySelector('[data-shipping-estimator]');
    const totals = cart.querySelector('[data-net-totals]');
    const currency = box?.dataset.currency || 'EUR';
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {style: 'currency', currency}).format(cents / 100);
    const netOf = cents => Math.round(cents / 1.19);
    const goodsGross = Number(totals?.dataset.goodsGross);
    const fields = [...form.querySelectorAll('[name="updates[]"]')];
    let dirty = false, version = 0, controller;
    const text = (selector, value) => { const node = totals?.querySelector(selector); if (node) node.textContent = value; };
    const renderTotals = shippingGross => {
      if (!totals) return;
      const quoted = Number.isSafeInteger(shippingGross) && shippingGross >= 0;
      const goodsNet = netOf(goodsGross);
      const shippingNet = quoted ? netOf(shippingGross) : 0;
      text('[data-goods-net]', money(goodsNet));
      text('[data-shipping-net]', quoted ? money(shippingNet) : totals.dataset.unquoted);
      text('[data-combined-vat]', money(goodsGross - goodsNet + (quoted ? shippingGross - shippingNet : 0)));
      text('[data-gross-total]', money(goodsGross + (quoted ? shippingGross : 0)));
      text('[data-vat-label]', totals.dataset[quoted ? 'vatAll' : 'vatGoods']);
      text('[data-total-label]', totals.dataset[quoted ? 'totalAll' : 'totalGoods']);
      text('[data-total-note]', totals.dataset[quoted ? 'estimated' : 'pending']);
    };
    const input = box?.querySelector('[data-shipping-zip]');
    const button = box?.querySelector('[data-shipping-calculate]');
    const output = box?.querySelector('[data-shipping-result]');
    const invalidate = () => {
      version++;
      controller?.abort();
      renderTotals(null);
      if (output) output.textContent = dirty ? messages.changed : messages.quote_needed;
      if (button) button.disabled = dirty;
      if (input) input.required = false;
    };
    const markDirty = () => {
      dirty = true;
      invalidate();
      cart.querySelectorAll('[data-tier-hint]').forEach(node => { node.hidden = true; });
      text('[data-total-note]', messages.changed);
    };
    fields.forEach(field => field.addEventListener('input', markDirty));
    document.addEventListener('cart:updated', markDirty);
    document.addEventListener('cart:change', markDirty);
    window.addEventListener('pageshow', event => { if (event.persisted) window.location.reload(); });
    cart.querySelectorAll('[data-tier-quantity]').forEach(button => {
      button.addEventListener('click', () => {
        if (dirty) return;
        const input = button.closest('.adler-cart__item')?.querySelector('[name="updates[]"]');
        if (!input) return;
        input.value = button.dataset.tierQuantity;
        if (!input.reportValidity()) return;
        input.dispatchEvent(new Event('input', {bubbles: true}));
        const submit = form.querySelector('[type="submit"][name="update"]');
        if (form.requestSubmit) form.requestSubmit(submit); else submit.click();
      });
    });
    if (!box || !input || !button || !output) return;
    input.addEventListener('input', invalidate);
    button.addEventListener('click', async () => {
      if (dirty) return;
      input.required = true;
      if (!input.reportValidity()) return;
      invalidate();
      const requestVersion = version;
      const zip = input.value.trim();
      controller = new AbortController();
      const signal = controller.signal;
      button.disabled = true;
      output.textContent = messages.loading;
      const query = new URLSearchParams({'shipping_address[zip]': zip, 'shipping_address[country]': 'Germany'});
      const signature = value => JSON.stringify([value.total_price, value.currency, value.items.map(item => [item.key, item.quantity, item.final_line_price])]);
      const getCart = async () => {
        const response = await fetch(root + 'cart.js', {signal, cache: 'no-store'});
        if (!response.ok) throw new Error();
        return response.json();
      };
      try {
        const before = await getCart();
        const shownQuantities = fields.map(field => Number(field.value));
        if (before.items.length !== shownQuantities.length || before.items.some((item, index) => item.quantity !== shownQuantities[index]) || (totals && before.total_price !== goodsGross)) {
          markDirty();
          return;
        }
        const prepare = await fetch(root + 'cart/prepare_shipping_rates.json?' + query, {method: 'POST', signal});
        if (!prepare.ok) throw new Error();
        let result = null;
        for (let attempt = 0; attempt < 12 && result === null; attempt++) {
          await new Promise(resolve => setTimeout(resolve, 1000));
          if (signal.aborted) return;
          const response = await fetch(root + 'cart/async_shipping_rates.json?' + query, {signal, cache: 'no-store'});
          if (!response.ok) throw new Error();
          result = await response.json();
        }
        if (signal.aborted || version !== requestVersion || dirty || zip !== input.value.trim()) return;
        const after = await getCart();
        if (signature(before) !== signature(after)) { markDirty(); return; }
        if (!result) throw new Error();
        const rates = (result.shipping_rates || []).map(rate => ({
          name: rate.presentment_name || rate.name,
          gross: rate.price === null || rate.price === '' ? NaN : Math.round(Number(rate.price) * 100),
          currency: rate.currency || currency
        })).filter(rate => typeof rate.name === 'string' && Number.isSafeInteger(rate.gross) && rate.gross >= 0 && rate.currency === currency).sort((a, b) => a.gross - b.gross);
        output.replaceChildren();
        if (!rates.length) { output.textContent = messages.rate_empty; return; }
        const label = document.createElement('label');
        const select = document.createElement('select');
        select.id = 'AdlerShippingChoice';
        label.htmlFor = select.id;
        label.textContent = messages.rate_label;
        rates.forEach((rate, index) => select.add(new Option(rate.name + ' · ' + money(totals ? netOf(rate.gross) : rate.gross) + ' ' + (totals ? messages.rate_net : messages.rate_gross), String(index))));
        const note = document.createElement('small');
        note.textContent = messages.rate_note;
        output.append(label, select, note);
        select.addEventListener('change', () => { if (!dirty && requestVersion === version) renderTotals(rates[Number(select.value)].gross); });
        renderTotals(rates[0].gross);
      } catch (error) {
        if (!signal.aborted && requestVersion === version) { renderTotals(null); output.textContent = messages.rate_error; }
      } finally {
        if (requestVersion === version) { button.disabled = dirty; input.required = false; }
      }
    });
  });
})();
